import { useEffect } from 'react';
import { Header } from '../../../components/feature/Header';
import { Footer } from '../../../components/feature/Footer';
import TenantsLeasesHero from './components/TenantsLeasesHero';
import UnderstandingTenantRights from './components/UnderstandingTenantRights';
import CommunicatingWithTenants from './components/CommunicatingWithTenants';
import LeaseAssignmentProcess from './components/LeaseAssignmentProcess';
import TenantOccupiedVsVacant from './components/TenantOccupiedVsVacant';
import HandlingLeaseExpirations from './components/HandlingLeaseExpirations';
import SecurityDepositTransfer from './components/SecurityDepositTransfer';
import TenantEstoppelCertificates from './components/TenantEstoppelCertificates';
import DealingWithProblemTenants from './components/DealingWithProblemTenants';
import RentRollDocumentation from './components/RentRollDocumentation';
import LeaseReviewDueDiligence from './components/LeaseReviewDueDiligence';
import TenantRetentionStrategies from './components/TenantRetentionStrategies';
import EvictionConsiderations from './components/EvictionConsiderations';
import MonthToMonthTenancies from './components/MonthToMonthTenancies';
import BuyerTenantRelationship from './components/BuyerTenantRelationship';
import StateLawCompliance from './components/StateLawCompliance';
import TimingYourSaleWithLeases from './components/TimingYourSaleWithLeases';
import TenantsLeasesFAQ from './components/TenantsLeasesFAQ';
import TenantsLeasesFinalCTA from './components/TenantsLeasesFinalCTA';

export default function TenantsAndLeasesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <TenantsLeasesHero />
        <UnderstandingTenantRights />
        <CommunicatingWithTenants />
        <LeaseAssignmentProcess />
        <TenantOccupiedVsVacant />
        <HandlingLeaseExpirations />
        <SecurityDepositTransfer />
        <TenantEstoppelCertificates />
        <DealingWithProblemTenants />
        <RentRollDocumentation />
        <LeaseReviewDueDiligence />
        <TenantRetentionStrategies />
        <EvictionConsiderations />
        <MonthToMonthTenancies />
        <BuyerTenantRelationship />
        <StateLawCompliance />
        <TimingYourSaleWithLeases />
        <TenantsLeasesFAQ />
        <TenantsLeasesFinalCTA />
      </main>
      <Footer />
    </div>
  );
}
